import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { ContactsModule } from "src/app/components/elementi-strutturali/contacts/contacts.module";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { SharedModuleModule } from "src/app/shared/shared-module/shared-module.module";
import { ServiceLayoutComponent } from "./service-layout.component";

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, BreadcrumbsModule, SharedModuleModule, SocialShareComponent, ActionsListComponent, ContactsModule],
  declarations: [ServiceLayoutComponent],
  exports: [ServiceLayoutComponent],

})
export class ServiceLayoutModule {
  static component = ServiceLayoutComponent
}